<template>
  <div id="app">
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-title v-if="!update" class="headline indigo white--text"
            >Fis Ekle</v-card-title
          >
          <v-card-title v-if="update" class="headline indigo white--text"
            >Fis Guncelle</v-card-title
          >
          <v-card-text>
            <v-form v-model="isFormValid">
              <v-layout row wrap v-if="!update">
              <v-flex xs12 sm6 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <tarihim
                      :etiket="$t('Bill-Date')"
                      :detaygizle="false"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="fisParams.RecieptDate"
                      :aktifmi="update"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="$t('Bill-No')"
                      v-model="fisParams.RecieptNumber"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <fistipi v-model="fisParams.ReciptType" :rules="[(v) => !!v || $t('Please-Choose')]"></fistipi>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="$t('Bill-Explanation')"
                      v-model="fisParams.RecieptTitle"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <merkez v-model="fisParams.Center" :rules="[(v) => !!v || $t('Please-Choose')]"> </merkez>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="update">
              <v-flex xs12 sm6 md6>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <tarihim
                      :etiket="$t('Bill-Date')"
                      :detaygizle="false"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="fisParams.RecieptDate"
                      :aktifmi="update"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="$t('Bill-No')"
                      v-model="fisParams.RecieptNumber"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <fistipi v-model="fisParams.ReciptType" :rules="[]"></fistipi>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="$t('Bill-Explanation')"
                      v-model="fisParams.RecieptTitle"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <merkez v-model="fisParams.Center" :rules="[]"> </merkez>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    :label="$t('E-Ledger-Document-No')"
                    v-model="fisParams.ERegistryDocNo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <tarihim
                    :etiket="$t('E-Ledger-Document-Date')"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                    v-model="fisParams.ERegistryDocDate"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    :label="$t('E-Ledger-Payment-Type')"
                    v-model="fisParams.ERegistryPaymentType"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    :label="$t('E-Ledger-Document-Type')"
                    :items="edefterDokumanTipi"
                    item-text="text"
                    item-value="value"
                    v-model="fisParams.ERegisrtyDocType"
                    @input="controlDocType()"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    :label="$t('E-Ledger-Explanation')"
                    v-model="fisParams.ERegistryDocExplain"
                    :disabled="controlDocExplain"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
</v-form>
           
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="closeDialog()">{{ $t('cancel_button') }}</v-btn>
            <v-btn color="primary" :disabled="isAddButtonDisabled" flat @click="addFis()" v-if="!update"
              >{{ $t('save_button') }}</v-btn
            >
            <v-btn color="primary" :disabled="isAddButtonDisabled" flat @click="addFis()" v-if="update"
              >Guncelle</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import tarihim from "@/components/app/customcomp/tarihim";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import fistipi from "@/components/app/muhasebe/comp/fistipi.vue";
import merkez from "@/components/app/muhasebe/comp/merkez.vue";
import auth from "@/api/auth";

export default {
  data() {
    return {
      isFormValid: false,
      fisTipi: {
        ID: null,
        RecieptTypeName: null,
      },
      fisParams: {
        UserID: 0,
        CompanyID: 0,
        RecieptID: 0,
        RecieptDate: null,
        RecieptNumber: null,
        Center: null,
        ReciptType: null,
        RecieptTitle: null,
        ERegistryDocNo: null,
        ERegistryDocDate: null,
        ERegisrtyDocType: 0,
        ERegistryPaymentType: null,
        ERegistryDocExplain: null,
        SavedDate: null,
        SavedUserID: null,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: 0,
        Lines: [],
        Logs: [],
        TotalCredit: 0.0,
        TotalDept: 0.0,
        TotalBalance: 0.0,
      },
      edefterDokumanTipi: [
        {
          text: this.$t('Check'),
          value: 0,
        },
        {
          text: this.$t('Bill'),
          value: 1,
        },
        {
          text: this.$t('Customer-Order'),
          value: 2,
        },
        {
          text: this.$t('Seller-Order'),
          value: 3,
        },
        {
          text: this.$t('Note-v2'),
          value: 4,
        },
        {
          text: this.$t('Freight'),
          value: 5,
        },
        {
          text: this.$t('Receipt-v2'),
          value: 6,
        },
        {
          text: this.$t('Other'),
          value: 7,
        },
      ],
      dialog: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      controlDocExplain: true,
      update: false,
    };
  },
  computed: {
    isAddButtonDisabled() {
      return !(this.fisParams.Center && this.fisParams.ReciptType && this.fisParams.RecieptDate);  
    },
  },
  methods: {
    updateDialog(val) {
      this.dialog = true;
      this.fisParams = val;
      this.controlDocType();
      this.update = true;
    },
    controlDocType() {
      if (this.fisParams.ERegisrtyDocType == 7) {
        this.controlDocExplain = false;
      } else {
        this.controlDocExplain = true;
      }
    },
    addFis() {
     
      this.loadingvmodel = true;
      this.fisParams.UserID = this.credentials.UserID;
      this.fisParams.CompanyID = this.credentials.MuhasebeSirketNo;
      if (this.update==false)
      {
        this.fisParams.ERegisrtyDocType=7;
      }
      this.fisParams.Lines=[];
      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptSave",
          this.fisParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
              if (!this.update) {
                this.loadingvmodel = false;
                let url =
                  "#/muhasebe/fisler/detay/id?islem=get&fisID=" +
                  response.body.SaveID;
                window.open(url, "_blank");
              } else {
                window.location.reload();
                this.loadingvmodel = false;
              }
              this.loadingvmodel = false;

              this.dialog = false;
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    closeDialog() {
      this.dialog = false;
      // var url = "#/muhasebe/fisler/liste";
      // window.open(url, "_self");
    },
    open() {
      this.dialog = true;
      this.update = false;
      if (this.update == false) {
        this.RecieptCounterLoad();
      }
    },
    RecieptCounterLoad() {
      if (this.update == false) {
      
        let params = {
          RecieptDate: this.fisParams.RecieptDate,
          RecieptNumber: 0,
          CompanyID:this.credentials.MuhasebeSirketNo
        };
        this.$http
          .post(
            auth.API_URL + "api/AccountingReciepts/RecieptCounterLoad",
            params,
            {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            }
          )
          .then(
            (response) => {
              this.fisParams.RecieptNumber = response.body;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-RecieptCounterLoad";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-RecieptCounterLoad";
                this.snackbar = true;
              }
            }
          );
      }
    },
  },
  watch: {
    "fisParams.RecieptDate": function () {
      this.RecieptCounterLoad();
    },
  },
  components: {
    snackbarcomp,
    loadingcomp,
    tarihim,
    masrafmerkezicomp,
    fistipi,
    merkez,
  },
  mounted() {},
};
</script>

<style>
</style>

